import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import StarsRating from '../../../../Shared/StarsRating'

function JobApplicantRatings({ projectsRating, buyerRating }) {
  function ratings(scope, title) {
    return (
      <Fragment>
        <h5 className="heading-14">{title} rating:</h5>
        <StarsRating rating={scope.avg_rating} fractions={2} customClass="height-12" readonly />
        <span className="rating">
          <span className="text-semibold">{scope.avg_rating}</span>/5
          <span className="text-semibold"> ({scope.count} {scope.count > 1 ? 'ratings' : 'rating'})</span>
        </span>
      </Fragment>
    )
  }

  return (
    <div className="job-applicant__rating-modal">
      {ratings(projectsRating, 'Projects')}
      {ratings(buyerRating, 'Model')}
    </div>
  )
}

JobApplicantRatings.propTypes = {
  projectsRating: PropTypes.shape({
    avg_rating: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
  }).isRequired,
  buyerRating: PropTypes.shape({
    avg_rating: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
  }).isRequired,
}

export default JobApplicantRatings
